/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Filter_ApproxInputs */

const en_ui_filter_approx = /** @type {(inputs: Ui_Filter_ApproxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`about ${i?.value}`)
};

const de_ui_filter_approx = /** @type {(inputs: Ui_Filter_ApproxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ca. ${i?.value}`)
};

/**
* | output |
* | --- |
* | "about {value}" |
*
* @param {Ui_Filter_ApproxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_approx = /** @type {((inputs: Ui_Filter_ApproxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_ApproxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_approx(inputs)
	return de_ui_filter_approx(inputs)
});